import SiderLayout from "../../layouts/SiderLayout";

import { UsersSlider } from "../../pages/Users/UserSlider/user.slider";
import React from "react";
import routes from "../routes";
import { generateChildren } from "./RouterGenerator";

let childrenNormal = generateChildren([
  routes.users().detail,
]);

export const usersRoutes = [
  {
    path: routes.users().path,
    handle: {
      crumb: e => routes.users().ressourceCrumb(e),
    },
    element: (
      <SiderLayout>
        <UsersSlider></UsersSlider>
      </SiderLayout>
    ),
    children: [
      {
        path: routes.users().detail.path,
        handle: {
          crumb: e => routes.users().crumb(e),
        },
        children: childrenNormal,
      },
    ],
  },
];
